"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./invalidTokenInterceptor");
require("./productHeaderInterceptor");
